import { FinanceFormType } from 'components/shared/FinanceCalculator/context';
import { CalculationsValues } from '../useCalculations';
import CalcuationRowBorrow from './Borrow';
import CalculationRowMonthly from './Monthly';

export interface CalculationRowProps {
  values: CalculationsValues;
  type: FinanceFormType;
}

const CalculationRow: React.FunctionComponent<CalculationRowProps> = function ({
  values,
  type,
}) {
  return (
    <>
      <div className="col-span-2 border-t border-neutral-300" />
      <p className="text-16-24 text-left">{values.term} months</p>
      {type === 'monthlyPayments' ? (
        <CalculationRowMonthly values={values} />
      ) : (
        <CalcuationRowBorrow values={values} />
      )}
    </>
  );
};

export default CalculationRow;
